import { Duration } from 'moment';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { AcUser, IAcTeamMembership } from '@nimbus-portal/features/attendant-console/model/ac-user/ac-user.model';
import { ErrorAction } from '@nimbus-library/features/shared/ngxs/error-action.model';

export namespace AcUserProfileActions {
  const actionPrefix = '[AC User Profile]';

  export class LoadUserInfo {
    public static type = `${actionPrefix} Load User Info`;
    public constructor(public readonly userId?: string) {}
  }

  export class LoadUserInfoSuccess {
    public static type = `${actionPrefix} Load User Info success`;
    public constructor(public readonly payload: AcUser) {}
  }

  export class LoadUserInfoFailed extends ErrorAction {
    public static type = `${actionPrefix} Load User Info failed`;
    public constructor(error: unknown) {
      super(LoadUserInfo, error);
    }
  }

  export class LoadUserLicenseInfo {
    public static type = `${actionPrefix} Load User License Info`;
  }

  export class LoadUserLicenseInfoSuccess {
    public static type = `${actionPrefix} Load User License Info success`;
    public constructor(public readonly payload: MicrosoftGraph.LicenseDetails[]) {}
  }

  export class LoadUserLicenseInfoFailed extends ErrorAction {
    public static type = `${actionPrefix} Load User License Info failed`;
    public constructor(error: unknown) {
      super(LoadUserLicenseInfo, error);
    }
  }

  export class StartLoadAttendantState {
    public static type = `${actionPrefix} Start Load Attendant State`;
    public constructor(public readonly interval: Duration) {}
  }

  export class StopLoadAttendantState {
    public static type = `${actionPrefix} Stop Load Attendant State`;
  }

  export class LoadTeamsWidgetStates {
    public static type = `${actionPrefix} Load Teams Widget States`;
  }

  export class LoadTeamsWidgetStatesSuccess {
    public static type = `${actionPrefix} Load Teams Widget States success`;
    public constructor(public readonly widgetState: IAcTeamMembership) {}
  }

  export class LoadTeamsWidgetStatesFailed extends ErrorAction {
    public static type = `${actionPrefix} Load Teams Widget States failed`;
    public constructor(public readonly error: string) {
      super(LoadTeamsWidgetStates, error);
    }
  }
}
